export function replaceObjVal(obj, targetKey, replacement) {
    if (obj[targetKey]) {
        obj[targetKey] = replacement
        return true
    }

    for (let key in obj) {
        if (typeof obj[key] === 'object') {
            return replaceObjVal(obj[key], targetKey, replacement)
        }
    }

    return false
}